import { Link } from "react-router-dom";
import { ArrowUpRight, Lock, Lightning } from "@phosphor-icons/react";

export default function PlanGate({ tool, plan }) {
  return (
    <div className="border border-[#002FA7] bg-[#F5F5F5] p-8 md:p-10" data-testid="plan-gate">
      <Lock size={32} weight="duotone" className="text-[#002FA7]" />
      <p className="mt-4 font-mono text-xs uppercase tracking-[0.22em] text-[#002FA7]">Growth / Pro tool · locked</p>
      <h2 className="mt-2 font-display text-2xl sm:text-3xl md:text-4xl font-black tracking-tighter">
        {tool.name} is part of the Growth & Pro plans.
      </h2>
      <p className="mt-4 text-[#525252] max-w-xl">
        Your current plan: <strong className="text-[#0A0A0A] capitalize">{plan}</strong>.
        Upgrade to Growth or Pro to unlock this tool, higher generation limits, publishing workflows, and automation.
      </p>
      <div className="mt-6 flex flex-wrap gap-3">
        <Link to="/pricing" className="btn-primary" data-testid="plan-gate-upgrade">
          See pricing & upgrade <ArrowUpRight size={16} weight="bold" />
        </Link>
        <Link to="/dashboard" className="btn-secondary" data-testid="plan-gate-back">
          Back to free tools
        </Link>
      </div>
    </div>
  );
}

export function UsageCapBanner({ usage }) {
  if (!usage || usage.cap === null || usage.is_unlimited) return null;

  const used = Number(usage.used || 0);
  const cap = Number(usage.cap || 0);
  const baseRemaining = Number(usage.remaining || 0);
  const addonRemaining = Number(usage.addon_credits?.remaining || 0);
  const totalAvailable = Number(
    usage.total_available ?? Math.max(cap - used, 0) + addonRemaining
  );

  if (baseRemaining > 0) return null;

  if (addonRemaining > 0 && totalAvailable > 0) {
    return (
      <div className="border border-[#F59E0B] bg-[#FFFBEB] p-6" data-testid="usage-addon-banner">
        <p className="font-mono text-xs uppercase tracking-[0.22em] text-[#92400E]">Monthly limit reached · add-on active</p>
        <h3 className="mt-2 font-display text-xl sm:text-2xl font-black">
          You used {used} of your {cap} monthly generations.
        </h3>
        <p className="mt-2 text-[#525252]">
          You still have <strong>{addonRemaining}</strong> add-on generation{addonRemaining === 1 ? "" : "s"} available.
        </p>
        <div className="mt-4 inline-flex items-center gap-2 text-sm font-semibold text-[#92400E]">
          <Lightning size={16} weight="duotone" /> New generations will use add-on credits first.
        </div>
      </div>
    );
  }

  return (
    <div className="border border-[#DC2626] bg-[#FEF2F2] p-6" data-testid="usage-cap-banner">
      <p className="font-mono text-xs uppercase tracking-[0.22em] text-[#DC2626]">Monthly limit reached</p>
      <h3 className="mt-2 font-display text-xl sm:text-2xl font-black">
        You've used {used} of your {cap} generations this month.
      </h3>
      <p className="mt-2 text-[#525252]">
        {usage.can_buy_addon || usage.addon_credits?.can_buy_addons
          ? "Buy a one-off generation pack to continue now, or wait for the monthly reset."
          : "Upgrade to ship more now, or wait for the monthly reset."}
      </p>
      <Link to="/pricing" className="btn-primary mt-4 inline-flex" data-testid="usage-cap-upgrade">
        {usage.can_buy_addon || usage.addon_credits?.can_buy_addons ? "Buy add-on credits" : "Upgrade"} <ArrowUpRight size={16} weight="bold" />
      </Link>
    </div>
  );
}
